export const setCustomerUserId = (id) => {
    if (typeof window.AF !== 'function') return;
    window.AF('pba', 'setCustomerUserId', id);
};

export const recordEvent = (eventName = 'event') => {
    if (typeof window.AF !== 'function') return;
    window.AF('pba', 'event', {
        eventType: 'EVENT',
        eventName,
    });
};
